import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WeatherRiskContextCard from "../../weather/risk/WeatherRiskContextCard";
import { fetchWeatherRiskForProperty } from "../../../weather/colombiaWeatherRiskApi";

const PropertyWeatherRiskCard = ({ propertyId, coordinates }) => {
  const navigate = useNavigate();
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!propertyId) {
      return undefined;
    }

    let cancelled = false;

    async function load() {
      setLoading(true);
      setErrorMessage("");

      try {
        const result = await fetchWeatherRiskForProperty(propertyId);
        if (!cancelled) {
          setPayload(result);
        }
      } catch (error) {
        if (!cancelled) {
          setPayload(null);
          setErrorMessage(error.message || "Unable to load weather risk context.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [propertyId]);

  if (!propertyId) {
    return null;
  }

  if (!coordinates?.latitude && !coordinates?.longitude && !loading && !payload) {
    return (
      <WeatherRiskContextCard
        payload={{
          available: false,
          message:
            "Weather Risk Context unavailable because this property does not have coordinates.",
        }}
      />
    );
  }

  return (
    <WeatherRiskContextCard
      payload={payload}
      loading={loading}
      errorMessage={errorMessage}
      onViewInWeather={() => {
        const params = new URLSearchParams();
        if (coordinates?.latitude != null && coordinates?.longitude != null) {
          params.set("lat", String(coordinates.latitude));
          params.set("lng", String(coordinates.longitude));
        }
        navigate(`/?perspective=weather${params.toString() ? `&${params.toString()}` : ""}`);
      }}
    />
  );
};

export default PropertyWeatherRiskCard;
